<template>
  <div class="map-right-layers-add-files__item">
    <span class="map-right-layers-add-files__item__label">
      {{ itemRef.name }}
    </span>
    <div class="map-right-layers-add-files__item__coordinate-system">
      <Dropdown
        v-model="itemRef.coordinateSystem"
        option-label="name"
        :options="modelMapRef.coordinatesSystem"
        placeholder="Sistema de coordenadas"
        @change="onChangeCoordinate"
      />
    </div>
    <div class="map-right-layers-add-files__item__buttons">
      <span
        class="
          material-icons
          map-right-layers-add-files__item__buttons__button
          map-right-layers-add-files__item__buttons__button--red
        "
        @click="() => emits('click-remove')"
      >
        delete_outline
      </span>
    </div>
  </div>
</template>


<script setup>
// vue
import {inject, ref} from 'vue';

// Primevue
import Dropdown from 'primevue/dropdown';

// #region Props, Emits
const props___ = defineProps({
  item: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
const emits = defineEmits(['change-coordinate', 'click-remove']);
const itemRef = ref(props___.item);
// #endregion


// #region Params, Ref, Reactives, Computed
const modelMapRef = inject('modelMapRef');
// #endregion


// #region Functions
function onChangeCoordinate({value}) {
  emits('change-coordinate', value);
}
// #endregion


// #region Effects, Hooks
// ...
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.map-right-layers-add-files {
  &__item {
    padding: 10px;
    display: flex;
    align-items: center;

    &__label {
      flex: 1 1 100%;
    }

    &__buttons {
      flex: 0 0 auto;

      &__button {
        cursor: pointer;

        &--red {
          color: $brand__color--red;
        }
      }
    }
  }


}
</style>
